export interface BusSelection {
  currentBusId: number;
  currentBusStopId: number;
  selectedBusId: number;
  selectedBusStopId: number;
}

export const createEmptyBusSelection = (): BusSelection => ({
  currentBusId: -1,
  currentBusStopId: -1,
  selectedBusId: -1,
  selectedBusStopId: -1,
});

export const createRegisteredBusSelection = (
  busId: number,
  busStopId: number
): BusSelection => ({
  currentBusId: busId,
  currentBusStopId: busStopId,
  selectedBusId: busId,
  selectedBusStopId: busStopId,
});

export const selectBus = (
  selection: BusSelection,
  busId: number,
  busStopId: number
): BusSelection => ({
  ...selection,
  selectedBusId: busId,
  selectedBusStopId: busStopId,
});

export const resetBusSelection = (selection: BusSelection): BusSelection => ({
  ...selection,
  selectedBusId: selection.currentBusId,
  selectedBusStopId: selection.currentBusStopId,
});

export const hasBusSelectionChanged = (selection: BusSelection): boolean =>
  selection.selectedBusId !== selection.currentBusId;
